import './ClImageWrapp.css';

function ClImageWrapp(newProps) {

    let imgWrappEle;
    const props = {
        url: '', // url that points to the content
        mediaType: 'img', // coul be image/svg
        base64: null, // optional is case you dont want to pass a url
        wrappType: 'div', // it can be div, i or span
        ...newProps // alt tis an extra option
    }
    // console.log(props);

    const setMediaWrapp = (pWrappType) => {
        const allowedWrapps = ['div', 'i', 'span'];
        if (!allowedWrapps.filter(e => e === pWrappType).length) pWrappType = 'div';
        imgWrappEle = document.createElement(pWrappType);
        imgWrappEle.classList.add('cl-image-wrapp');
        if (pWrappType === 'i') imgWrappEle.classList.add('cl-image-wrapp--icon');
        return;
    }

    const setMediaType = (mediaType) => {
        if (!mediaType) return;
        if (mediaType.toLocaleLowerCase() === 'img') {
            const imgEle = document.createElement('img');
            if (props?.alt) imgEle.alt = props.alt;
            imgWrappEle.appendChild(imgEle);
        }
        return;
    };
    const setBase64 = (base64) => {
        if (!base64) return;
        removeChild();
        return;
    };
    const setUrl = async (url) => {
        if (!url) return;
        // removeChild();
        if (props.mediaType.toLocaleLowerCase() === 'img') {
            imgWrappEle.querySelector('img').src = url;
        }
        if (props.mediaType.toLocaleLowerCase() === 'svg') {
            const resContent = await fetch(url)
                .then(res => {
                    if (res?.status !== 200 && res?.status !== 201) {
                        const err = new Error(`Resource couldn't be fetched`);
                        err.status = res.status;
                        throw err;
                    }
                    return res.text();
                })
                .catch(err => {
                    console.error(err);
                    return '';
                });
            if (resContent) imgWrappEle.innerHTML = resContent;
            else {
                props.mediaType = 'img';
                setMediaType(props.mediaType);
                setUrl(url);
            }
        }
        return;
    };

    const build = async () => {
        const { url, mediaType, base64 } = props;
        setMediaType(mediaType);
        setBase64(base64);
        await setUrl(url);
        return imgWrappEle;
    }

    const removeChild = () => {
        if (imgWrappEle.children) {
            imgWrappEle.firstChild.remove();
        }
    }

    setMediaWrapp(props.wrappType);
    return {
        build
    }
}
export default ClImageWrapp;